export default "__VITE_ASSET__DsFWw3eq__"